import { useGetOpenCashRegistersQuery } from "@/services/store-conciliation";

export type OpenCashRegisters = {
  readonly codes: readonly number[];
  readonly hasAny: boolean;
  readonly isLoading: boolean;
};

// Endpoint próprio e não o do saldo parcial, que é payload de modal (ADR-CON-003).
export function useOpenCashRegisters(
  conciliationId: string | undefined,
): OpenCashRegisters {
  const { data, isLoading } = useGetOpenCashRegistersQuery(
    { conciliationId: conciliationId ?? "" },
    { skip: !conciliationId },
  );

  const codes: readonly number[] = data?.cash_register_codes ?? [];

  return { codes, hasAny: codes.length > 0, isLoading };
}
